import { prop } from "../../../decorators/property";

export class BasicTabState extends Backbone.Model {

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/basic-tab-state.ts